import { Flex, Image, Spinner } from '@chakra-ui/react';
import { memo } from 'react';

import { FontListOptionProps } from './FontFamilySelectMenu.types';
import { SelectMenuOption } from './SelectList';
import { Option } from './SelectList.types';

export const FontListOption = memo(
  ({
    value,
    imageUrl,
    isSelected,
    isLoading = false,
    isBrandFont = false,
    isDocumentFont = false,
    isUploadedFont = false,
  }: FontListOptionProps) => {
    const option = { value, imageUrl };

    return (
      <SelectMenuOption
        option={option as Option}
        isSelected={isSelected}
        isBrandFont={isBrandFont}
        isDocumentFont={isDocumentFont}
        isUploadedFont={isUploadedFont}
      >
        <Image w='100%' h='100%' objectFit='contain' src={imageUrl} alt={`Select ${value}`} />
        {isLoading && (
          <Flex data-testid={`loading-font-${value}`} right={2} h='100%' align='center' position='absolute'>
            <Spinner size='xs' />
          </Flex>
        )}
      </SelectMenuOption>
    );
  },
);
FontListOption.displayName = 'FontListOption';
